import { VerantosOrgEnum } from '@verantos-dev/core-enums';

interface ConceptGroupAuthUser {
  isInternalUser?: boolean;
  organizationId?: string;
  userId?: string;
  auth0Id?: string;
}

/**
 * Is the concept group editable at all? Verantos-curated groups are immutable; the
 * rest are open to internal users and members of the owning org. This is the gate the
 * org-wide library's actions column uses (`useConceptGroups.tsx`), and what Delete
 * needs — it is NOT sufficient for rename, which is owner-only.
 */
export const canEditConceptGroup = ({
  owner,
  organizationId,
  user,
}: {
  owner: string | null | undefined;
  organizationId: string | null | undefined;
  user: ConceptGroupAuthUser;
}): boolean =>
  owner?.toLowerCase() !== VerantosOrgEnum.VERANTOS.toLowerCase() &&
  Boolean(user.isInternalUser || (organizationId && organizationId === user.organizationId));

/**
 * Does this user own the concept group? Renaming is owner-only, so a colleague in the
 * same org never sees the affordance. Matched against both id forms, the way
 * `AnalyticalDatasetRowActions` does — the stored owner id can be either.
 */
export const isConceptGroupOwner = (
  ownerUserId: string | null | undefined,
  user: ConceptGroupAuthUser
): boolean =>
  Boolean(ownerUserId) && [user.userId, user.auth0Id].includes(ownerUserId ?? undefined);
